module.exports = __webpack_public_path__ + "static/media/Travelmaker Indonesia.69703fe3.png";